/**
 * Decorador utilizado somente para indicar que tal médoto pertence ao pertal do servidor
 */
// tslint:disable-next-line:no-empty
export function PortalServidor() {
  // tslint:disable-next-line:no-empty
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
  };
}
